import styled from "styled-components";

export const Container = styled.div`
  display: inline-block;
  position: relative;
`;
export const ButtonShare = styled.button`
  display: flex;
  align-items: center;
  background-color: #456dd6;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 4px 8px;
  text-transform: uppercase;
  box-sizing: border-box;
  font-size: 13px;
  cursor: pointer;
`;

export const ModalContainer = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: #000000b8;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ModalContent = styled.div`
  border: 1px solid #707070;
  border-radius: 8px;
  padding: 20px 10px;
  background-color: #fff;
  width: 320px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
`;

export const Title = styled.p`
  font-size: 24px;
  line-height: 1;
  font-weight: 900;
  padding-bottom: 10px;
  border-bottom: 2px solid #00000014;
  margin: 0;
  text-align: center;
  width: 100%;
`;

export const IconContainer = styled.div`
  width: 56px;
  height: 56px;
  margin: 20px 5px;
  cursor: pointer;
`;

export const IconText = styled.span`
  font-size: 10px;
  line-height: 1;
  color: #000000;
  font-weight: 900;
  text-align: center;
  width: 100%;
  display: block;
  margin-top: 3px;
`;

export const IconTextLarge = styled.span`
  font-size: 30px;
  line-height: 40px;
  color: #000000;
  font-weight: 900;
  text-align: center;
  width: 100%;
  display: block;
`;

export const Textarea = styled.textarea`
  width: 100%;
  min-height: 74px;
  height: auto;
  border: 1px solid #c5c5c5;
  border-radius: 8px;
  padding: 10px;
  font-size: 16px;
  line-height: 1;
  font-family: "Rajdhani";
`;
export const CopiedMessage = styled.p`
  background-color: #339d37;
  color: #fff;
  font-size: 16px;
  line-height: 24px;
  border-radius: 8px;
  padding: 5px;
  margin: 0;
  position: absolute;
  top: 10px;
  right: 10px;
`;

export const RelativeContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const IconsContainer = styled.div`
  width: ${(props) => (props.fullWidth ? "100%" : "220px")};
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
`;
